import React from 'react';
import styles from './index.module.sass';

export default function FinishPage() {
  return <div className={styles.container}>Ya puedes cerrar esta ventana</div>;
}
